import React, { useEffect } from 'react'
import { CUSTOM_EVENT_NAME } from '@typesApp/AppEvent'
import { useAppErrorHandler } from './hooks/useAppErrorHandler'
import { useAppDrawerEventListener } from './hooks/useAppDrawerEventListener'
import { Drawer } from '@components/ui-css/Drawer/Drawer'
import { AppRoutes } from './components/AppRoutes'
import { DrawerTopHeader } from './components/DrawerTopHeader/DrawerTopHeader'
import { useAppDrawer } from './hooks/useAppDrawer'
import { useAppDrawerState } from './hooks/useAppDrawerState'

export const AppContainer: React.FC = () => {
  const { onClose, onNavigateBack } = useAppDrawer()
  const { isVisible, showHeader, hideCloseButton } = useAppDrawerState()
  const eventListener = useAppDrawerEventListener()

  useAppErrorHandler()

  /**
   * Handle drawer events
   */
  useEffect(() => {
    document.addEventListener(CUSTOM_EVENT_NAME.DRAWER, eventListener)
    return () => {
      document.removeEventListener(CUSTOM_EVENT_NAME.DRAWER, eventListener)
    }
  }, [eventListener])

  return (
    <Drawer
      open={isVisible}
      hideCloseButton={!showHeader || hideCloseButton}
      onClose={onClose}
      topHeader={showHeader ? <DrawerTopHeader onNavigateBack={() => onNavigateBack?.()} /> : undefined}
    >
      <AppRoutes />
    </Drawer>
  )
}
